<template>
  <div>
    <el-card>
      <div class="top">
        <div class="left">
          <span class="order-detail">订单详情</span>
        </div>
        <div class="right">
          <!-- <el-button><i class="el-icon-download"></i> 导出</el-button>
          <el-button> <i class="el-icon-printer"></i>打印</el-button> -->
          <el-button @click="back">
            <i class="el-icon-arrow-left
"></i>返回</el-button>
        </div>
      </div>
      <div class="line" style="height: 1px;background-color: #e8e8e8;margin-top: 16px;"></div>
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <span style="margin-right: 4px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"></span>
        <span style="font-weight: 700;">订单号 {{ data.orderNumber }}</span>
        <span class="yjz">{{
          data.isCheckOut == 1 ? "已结账" : "未结账"
        }}</span>
        <!-- <span style="font-size: 12px;color: #FD8D02;margin-left: 10px;"
          >查看联台订单号明细</span
        > -->
      </div>
      <div class="three-card">
        <div class="item">
          <div class="top">
            <span>订单金额(元)</span>
            <span style="margin-left: 8px;">{{ data.sumToPay }}</span>
          </div>
        </div>
        <div class="item">
          <div class="top">
            <span>订单优惠(元)</span>
            <span style="margin-left: 8px;">{{
              data.sumToPay == null || data.sumPaid == null
                ? "--"
                : data.sumToPay - data.sumPaid
            }}</span>
          </div>
          <div class="bottom">
            <!-- <span>折扣优惠-0.00 + 支付优惠-0.00</span> -->
          </div>
        </div>
        <div class="item">
          <div class="top">
            <span>订单收入(元)</span>
            <span style="margin-left: 8px;">{{ data.sumPaid }}</span>
          </div>
        </div>
      </div>
      <div class="three-detail">
        <div class="item">
          <span>门店：<span v-if="data.merchantName != ''">{{
            data.merchantName
          }}</span>
            <span v-else>--</span>
          </span>
          <!-- <span>用餐方式：<span v-if="data.deliveryType!=''">{{ data.deliveryType==0?'堂食':'配送' }}</span>
            <span v-else>--</span>
            </span>
            <span>平台服务费：<span>--</span></span> -->
          <span>会员姓名：<span v-if="data.memberName != ''">{{
            data.memberName
          }}</span>
            <span v-else>--</span>
          </span>
          <span>下单时间：<span v-if="data.beginTime">{{
            data.beginTime | dataFormat
          }}</span>
            <span v-else>--</span>
          </span>
          <span>结账来源系统：
            <span v-if="data.sourceCode == 'cashier'">收银</span>
            <span v-if="data.sourceCode == 'wap'">网页</span>
            <span v-if="data.sourceCode == 'mini'">微信小程序</span>
            <span v-if="data.sourceCode == 'ele'">饿了么</span>
            <span v-if="data.sourceCode == 'meituan'">美团</span>
            <span v-if="data.sourceCode == 'miniScan'">扫码点单</span>
            <span v-if="data.sourceCode == 'wx_jsapi'">微信收款码扫码</span>
            <span v-if="data.sourceCode == 'alipay_jsapi'">支付宝收款码扫码</span>
            <span v-if="data.sourceCode == ''">--</span>
          </span>
          <span>收银员：<span v-if="data.checkOutUserCode">{{
            data.checkOutUserCode
          }}</span>
            <span v-else>--</span>
          </span>
          <span>收货人/提货人姓名：<span v-if="data.distributorName != ''">{{
            data.distributorName
          }}</span>
            <span v-else>--</span>
          </span>
        </div>
        <div class="item">
          <span>订单来源：
            <span v-if="data.sourceCode == 'cashier'">收银</span>
            <span v-if="data.sourceCode == 'wap'">网页</span>
            <span v-if="data.sourceCode == 'mini'">微信小程序</span>
            <span v-if="data.sourceCode == 'ele'">饿了么</span>
            <span v-if="data.sourceCode == 'meituan'">美团</span>
            <span v-if="data.sourceCode == 'miniScan'">扫码点单</span>
            <span v-if="data.sourceCode == 'wx_jsapi'">微信收款码扫码</span>
            <span v-if="data.sourceCode == 'alipay_jsapi'">支付宝收款码扫码</span>
            <span v-if="data.sourceCode == ''">--</span>
          </span>
          <span>桌号：<span v-if="data.tableName != ''">{{ data.tableName }}</span>
            <span v-else>--</span></span>
          <span>用餐人数：<span v-if="data.peopleCount">{{
            data.peopleCount
          }}</span>
            <span v-else>--</span>
          </span>
          <span>营业日期：<span v-if="data.businessDate">{{
            data.businessDate | dataFormat
          }}</span>
            <span v-else>--</span>
          </span>

          <span>折扣备注：<span v-if="data.discountName != ''">{{
            data.discountName
          }}</span>
            <span v-else>--</span>
          </span>
          <span>收货人/提货人手机号：<span v-if="data.distributorPhone">{{
            data.distributorPhone
          }}</span>
            <span v-else>--</span>
          </span>
        </div>
        <div class="item">
          <!-- <span>业务类型：<span>--</span></span> -->
          <span>桌台类型：<span v-if="data.tableTypeName != ''">{{
            data.tableTypeName
          }}</span>
            <span v-else>--</span>
          </span>
          <span>会员手机号：
            <span v-if="data.memberCardID">{{ data.memberCardID }}</span>
            <span v-else>--</span></span>
          <span>下单人手机号：
            <span v-if="data.beginUserCode">{{ data.beginUserCode }}</span>
            <span v-else>--</span>
          </span>
          <span>结账时间：<span v-if="data.orderDt != '' && data.orderDt != null">{{ data.orderDt | dataFormat }}</span>
            <span v-else>--</span>
          </span>
          <span>整单备注：<span v-if="data.orderRemark != ''">{{
            data.orderRemark
          }}</span>
            <span v-else>--</span>
          </span>
          <span>收货地址：<span v-if="data.distributorAddress">{{
            data.distributorAddress
          }}</span>
            <span v-else>--</span>
          </span>
        </div>
      </div>
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <span style="margin-right: 4px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"></span>
        <span style="font-weight: 700;">菜品信息</span>
        <span style="margin-left: 6px;font-size: 14px;" v-if="data.tableName">({{ data.tableName }})</span>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="productCode" label="菜品编码" width="180"></el-table-column>
        <el-table-column prop="productName" label="菜品名称"></el-table-column>
        <el-table-column prop="normalPrice" label="单价"></el-table-column>
        <el-table-column prop="num" label="数量"></el-table-column>
        <el-table-column label="小计">
          <template slot-scope="scope">
            {{ scope.row.normalPrice * scope.row.num }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="零售" prop="saleNum"></el-table-column> -->
        <el-table-column label="单位" prop="unit"></el-table-column>
        <!-- <el-table-column label="金额合计(元)" prop="sumPrice"></el-table-column> -->
        <!-- <el-table-column label="菜品优惠(元)" prop="菜品优惠(元)"></el-table-column> -->
        <!-- <el-table-column label="菜品收入(元)" prop="payPrice"></el-table-column> -->
        <el-table-column label="备注" prop="remark"></el-table-column>
        <!-- <el-table-column label="税率" prop="税率"></el-table-column> -->
        <!-- <el-table-column label="税额(元)" prop="taxSum"></el-table-column> -->
        <!-- <el-table-column label="不含税金额(元)" prop="不含税金额(元)"></el-table-column> -->
        <!-- <el-table-column label="备注" prop="备注"></el-table-column>
    <el-table-column label="备注" prop="备注"></el-table-column> -->
      </el-table>
      <div style="display: flex;align-items: center;margin-top: 30px;">
        <span style="margin-right: 4px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"></span>
        <span style="font-weight: 700;">支付信息</span>
      </div>
      <el-table v-if="isSale == true" :data="payData" style="width: 100%">
        <el-table-column label="支付时间">
          <template slot-scope="scope">
            {{ scope.row.checkOutTime | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column label="订单号" prop="orderNumber"></el-table-column>
        <el-table-column label="支付订单号" prop="backTranNo"></el-table-column>
        <el-table-column label="支付金额(元)" prop="sumPaid"></el-table-column>
        <!-- <el-table-column label="收单手续费(元)" prop=""></el-table-column> -->
        <el-table-column label="支付渠道" prop="payChannel"></el-table-column>
        <el-table-column label="支付状态">
          <template slot-scope="scope">
            <span v-if="scope.row.isCheckOut == '0'">未结账</span>
            <span v-if="scope.row.isCheckOut == '1'">已结账</span>
            <span v-if="scope.row.isCheckOut == '2'">已退款</span>
            <span v-if="scope.row.isCheckOut == '3'">反结账</span>
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <el-table v-if="isSale == false" :data="payDatas" style="width: 100%">
        <el-table-column label="支付时间">
          <template slot-scope="scope">
            {{ scope.row.payTime | dataFormat }}
          </template>
        </el-table-column>
        <el-table-column label="订单号" prop="orderNumber"></el-table-column>
        <el-table-column label="支付订单号" prop="backTranNo"></el-table-column>
        <el-table-column label="支付金额(元)" prop="sumConsume"></el-table-column>
        <!-- <el-table-column label="收单手续费(元)" prop=""></el-table-column> -->
        <el-table-column label="支付渠道" prop="payTypeName"></el-table-column>
        <el-table-column label="支付状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">已支付</span>
            <span v-else>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <!-- <div style="display: flex;align-items: center;margin-top: 20px;" v-if="showLastTable"> -->
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <span style="margin-right: 4px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"></span>
        <span style="font-weight: 700;">退款信息</span>
      </div>
      <el-table :data="refundList">
        <el-table-column label="请求时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDt | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退款时间">
          <template slot-scope="scope">
            <span>{{ scope.row.backDt | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商户退款订单号" prop="outRefundNo"></el-table-column>
        <el-table-column label="退款订单号" prop="refundId"></el-table-column>
        <el-table-column label="退款金额(元)" prop="refundFee">
          <template slot-scope="scope">
            <span>{{ scope.row.refundFee / 100 }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="手续费退还"></el-table-column> -->
        <el-table-column label="退款状态">
          <template slot-scope="scope">
            <span v-if="scope.row.refundStatus == 'REFUND_ING'">退款中</span>
            <span v-if="scope.row.refundStatus == 'REFUND_SUCCESS'">退款成功</span>
          </template>
        </el-table-column>
        <el-table-column label="退款方式" prop="payChannel"></el-table-column>
        <el-table-column label="备注" prop="refundDesc"></el-table-column>
      </el-table>

      <div style="display: flex;align-items: center;margin-top: 20px;">
        <span style="margin-right: 4px;height: 18px;width: 4px;background-color: #ffc700;display: inline-block;"></span>
        <span style="font-weight: 700;">团购信息</span>
      </div>
      <el-table :data="couponList">
        <el-table-column align="center" width="190" label="名称" prop="dealTitle"></el-table-column>
        <el-table-column align="center" label="价格(元)" prop="couponBuyPrice"></el-table-column>
        <el-table-column align="center" label="商品" prop="content"></el-table-column>
        <el-table-column align="center" label="核销时间">
          <template slot-scope="scope">
            <span>{{ scope.row.updateDt | dataFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">未核销</span>
            <span v-if="scope.row.status == 1">已核销</span>
            <span v-if="scope.row.status == 2">已撤销</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="券购买价"
        prop="券购买价,即用户在购买团购券时所付的实际价格。返回-1则表示没查到couponBuyPrice信息">
        <template slot-scope="scope">
            <span v-if="scope.row.couponBuyPrice!=-1">
                {{scope.row.couponBuyPrice}}
            </span>
        </template>
        </el-table-column> -->
        <el-table-column align="center" label="券类型" prop="">
          <template slot-scope="scope">
            <span v-if="scope.row.voucher == true">代金券</span>
            <span v-if="scope.row.voucher == false">套餐券</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      couponList: [],
      isSale: true,
      tableData: [],
      data: {},
      payData: [],
      payDatas: [],
      showLastTable: false,
      refundList: []
    };
  },
  methods: {
    getLoadInfo() {
      this.$http
        .post("/merchantOrderItems/queryOrderItem", {
          orderNumber: this.$route.query.orderNumber
        })
        .then(res => {
          console.log(res, "xinxi");
          this.tableData = res.data.data.orderItemList;
          this.data = res.data.data.merchantOrder;
          this.couponList = res.data.data.couponList;
          if (this.isSale) {
            this.payData.push(res.data.data.merchantOrder);
          } else {
            this.payDatas = res.data.data.merchantOrderPayinfo;
          }

          if (res.data.data.refundList) {
            this.showLastTable = true;
            this.refundList = res.data.data.refundList;
          }
        });
    },
    back() {
      console.log(this.$route.query.orderType, '-----');
      if (this.$route.query.orderType === "history") {
        this.$router.push(
          "/statistics/history/historyOrderDetails?currPage=" +
          this.$route.query.currPage
        );
      } else if (this.$route.query.orderType === "payment") {
        this.$router.push(
          "/payment?currPage=" +
          this.$route.query.currPage
        );
      } else {
        this.$router.push(
          "/statistics/order/orderDetails?currPage=" +
          this.$route.query.currPage
        );
      }
    },
    getLoadInfos() {
      this.$http
        .post("merchantOrderItems/queryOrderItemHistory", {
          orderNumber: this.$route.query.orderNumber
        })
        .then(res => {
          console.log(res, "xinxi");
          this.tableData = res.data.data.orderItemList;
          this.data = res.data.data.merchantOrder;
          this.couponList = res.data.data.couponList;
          if (this.isSale) {
            this.payData.push(res.data.data.merchantOrder);
          } else {
            this.payDatas = res.data.data.merchantOrderPayinfo;
          }
          if (res.data.data.refundList) {
            this.showLastTable = true;
            this.refundList = res.data.data.refundList;
          }
        });
    }
  },
  created() {
    if (localStorage.getItem("versionCode") == "sale") {
      this.isSale = true;
    } else {
      this.isSale = false;
    }
    console.log(this.isSale);
    if (this.$route.query.orderType == "today") {
      this.getLoadInfo();
    } else {
      this.getLoadInfos();
    }
  }
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
  justify-content: space-between;

  .left {
    .order-detail {
      color: #333;
      font-weight: 500;
      font-size: 20px;
    }
  }

  .right {
    width: 95px;
  }
}

// 已结账
.yjz {
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 8px;
  color: #fff;
  background-color: #00c8b4;
  font-size: 12px;
  line-height: 24px;
  font-weight: 700;
  border-radius: 2px;
}

.three-card {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  .item {
    width: 27%;
    height: 65px;
    padding: 16px 24px;
    border: 1px solid #e9e9e9;

    .top {
      display: block;

      span {
        font-weight: 700;
      }
    }

    .bottom {
      margin-top: 10px;

      span {
        color: rgba(0, 0, 0, 0.65);
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
}

.three-detail {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;

  .item {
    border-right: 2px solid transparent;
    width: 27%;
    padding-right: 48px;
    display: flex;
    flex-direction: column;

    span {
      // display: inline-block;
      line-height: 22px;
      height: 22px;
      box-sizing: border-box;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      margin-bottom: 10px;

      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }
}

::-webkit-scrollbar-thumb {
  background: #999;
}
</style>
